import { defineStore } from 'pinia'

export interface State {
    loggedInUser: string | null
    loggedInUserIsAdmin: boolean
    theme: string
    cargoSmallLogo: string
    fslabsLogo: string
    rememberMe: boolean
    rememberMeUser: string | null
    searchCache: boolean
    lightBackgroundImage: string
    darkBackgroundImage: string
    currentBackgroundImage: string
}

export const useStore = defineStore('store', {
    state: (): State => ({
        loggedInUser: null,
        loggedInUserIsAdmin: false,
        theme: 'dark',
        cargoSmallLogo: 'img/cargo-logo-small-light.png',
        fslabsLogo: 'img/fslabs-logo-dark.png',
        rememberMe: false,
        rememberMeUser: null,
        searchCache: false,
        lightBackgroundImage: '',
        darkBackgroundImage: '',
        currentBackgroundImage: '',
    }),
    getters: {
        loggedIn: (state) => state.loggedInUser !== null,
        isDark: (state) => state.theme === 'dark'
    },
    actions: {
        login(payload: { "user": string, "is_admin": boolean }) {
            this.loggedInUser = payload.user
            this.loggedInUserIsAdmin = payload.is_admin
        },
        logout() {
            this.loggedInUser = null
            this.loggedInUserIsAdmin = false
        },
        toggleTheme() {
            // Toggle theme state - Vuetify and highlight.js themes are handled by ThemeToggle component
            if (this.theme === 'light') {
                this.theme = 'dark'
                this.fslabsLogo = 'img/fslabs-logo-dark.png'
                this.cargoSmallLogo = 'img/cargo-logo-small-dark.png'
            } else {
                this.theme = 'light'
                this.fslabsLogo = 'img/fslabs-logo-light.png'
                this.cargoSmallLogo = 'img/cargo-logo-small-light.png'
            }
        }
    },
    persist: true
})
